import { render } from "./table.vue?vue&type=template&id=191c8d90&scoped=true&ts=true"
import script from "./table.vue?vue&type=script&lang=ts"
export * from "./table.vue?vue&type=script&lang=ts"

import "./table.vue?vue&type=style&index=0&id=191c8d90&scoped=true&lang=less"

import exportComponent from "D:\\test\\newDemo\\alp-ui\\vue-component\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-191c8d90"]])

export default __exports__